var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPressedStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 24,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2.28868C8.8094 2.11004 9.1906 2.11004 9.5 2.28868L15.4282 5.71132C15.7376 5.88996 15.9282 6.22008 15.9282 6.57735V13.4226C15.9282 13.7799 15.7376 14.11 15.4282 14.2887L9.5 17.7113C9.1906 17.89 8.8094 17.89 8.5 17.7113L2.5718 14.2887C2.2624 14.11 2.0718 13.7799 2.0718 13.4226V6.57735C2.0718 6.22008 2.2624 5.88996 2.5718 5.71132L8.5 2.28868Z",
  fill: "#253F73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 2.28868L10 1.42265C9.3812 1.06538 8.6188 1.06538 8 1.42265L2.0718 4.8453C1.45299 5.20256 1.0718 5.86282 1.0718 6.57735V13.4226C1.0718 14.1372 1.45299 14.7974 2.0718 15.1547L8 18.5774C8.6188 18.9346 9.3812 18.9346 10 18.5774L15.9282 15.1547C16.547 14.7974 16.9282 14.1372 16.9282 13.4226V6.57735C16.9282 5.86282 16.547 5.20256 15.9282 4.8453L10 1.42265L9.5 2.28868Z",
  stroke: "#253F73",
  strokeOpacity: 0.4,
  strokeWidth: 2
})));
export { SvgPressedStop as ReactComponent };
export default __webpack_public_path__ + "assets/745c868b.svg";